import React from 'react'
import "./../../App.css"
import './footer.css'
import footermap from './../../Images/footer-map-03228220ebf2de382190bb2dfcc7eae2.png'
import logo from './../../Images/logo-05771722c25b257c52971d5243491863.png'
import {TiSocialFacebook , TiSocialLinkedin , TiSocialTwitter} from 'react-icons/ti'
import { PiInstagramLogo, PiMapPinLight, PiPhoneCall } from 'react-icons/pi'
import { MdOutlineWatchLater } from 'react-icons/md'
import { GoMail } from "react-icons/go"
export default function Footer() {
    return (
        <footer>
            <div className="container">
                <div className="row">
                    <div className="col-lg-4 col-sm-6 justify-content-start">
                        <div className="footer_inner_widget">
                            <a href="/" className='logo_main'><img src={logo} /></a>
                            <p>iHunar is the software and IT solution providing Company in Pakistan. We provide top notch Software Solutions combined with advanced learning through the iHunar Training Academy.</p>
                            <ul className="social_links">
                                <li>
                                    <a href="#" target='_blank'>
                                        <TiSocialFacebook/>
                                    </a>
                                </li>
                                <li>
                                    <a href="#" target='_blank'>
                                        <TiSocialTwitter/>
                                    </a>
                                </li>
                                <li>
                                    <a href="#" target='_blank'>
                                        <TiSocialLinkedin/>
                                    </a>
                                </li>
                                <li>
                                    <a href="#" target='_blank'>
                                        <PiInstagramLogo/>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-2 col-sm-6 justify-content-start">
                        <div className="footer_inner_widget pl-5">
                            <h3>Pages</h3>
                            <ul className='footer-links-list'>
                                <li><a href="/">Home</a></li>
                                <li><a href="/about">About Us</a></li>
                                <li><a href="/ourteam">Our Team</a></li>
                                <li><a href="/career/internship">Internships</a></li>
                                <li><a href="/carrer/jobs">Jobs</a></li>
                                <li><a href="#">Contact</a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-4 col-sm-6 justify-content-start">
                        <div className="footer_inner_widget">
                            <h3>Contact Us</h3>
                            <ul className='footer_contact_info'>
                                <li><PiMapPinLight /> 1st Floor Kallar House, North Colony, Mithi, <br /> Pakistan</li>
                                <li><PiPhoneCall /> <a href="tel:+92-33-22511711">+92-33-22511711</a></li>
                                <li><GoMail /> <a href="mailto:info@ihunar.com">info@ihunar.com</a></li>
                                <li><MdOutlineWatchLater /> Opening Hours: 09:00 - 17:00 </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="bottom_footer">
                    <div className="row">
                        <div className="col-lg-6 col-md-6">
                            <p>© 2021 All Rights Reserved. Design & Developed By iHunar</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="footer_map">
                <img src={footermap} />
            </div>
        </footer>
    )
}
